'use client'

import type { TBaseComponentProps } from '@segway/core'

import { Carousel, CarouselItem, ProductItem } from '@/components'

import { useProduct, useProductData } from '../../ProductProvider'

export type TRelatedProductsProps = TBaseComponentProps

const RelatedProducts = () => {
  const { responsive } = useProduct()
  const product = useProductData()

  return (
    <>
      {responsive && responsive.xl && !!product?.related_products?.length && (
        <div className="py-12">
          <h2 className="mb-[20px] font-miSansDemiBold450 text-pc-5xl xl:mb-[32px]">
            Frequently Brought With
          </h2>
          <div className="flex w-full">
            <Carousel
              autoPlay={false}
              showIndicators={false}
              isHoverShowArrows={true}
              showArrows={product.related_products.length > 4}
              className="-ml-2 w-full xl:-ml-0"
              arrowLeftContainerClassName="-left-[6.25%]"
              arrowRightContainerClassName="-right-[6.25%]"
              isArrowOut={true}>
              {product.related_products.map((item, index) => (
                <CarouselItem
                  key={index}
                  className={`min-w-0 basis-1/4 ${product?.related_products?.length && index !== product?.related_products?.length - 1 ? 'pr-4' : ''}`}>
                  {item ? <ProductItem product={item} /> : null}
                </CarouselItem>
              ))}
            </Carousel>
          </div>
        </div>
      )}
      {responsive && !responsive.xl && !!product?.related_products?.length && (
        <>
          <h3 className="mb-[20px] font-miSansDemiBold450 text-xl text-[#0F0F0F]">
            Frequently Brought With
          </h3>
          <div className="grid grid-cols-2 gap-x-[11px] gap-y-[36px]">
            {product?.related_products.map((item, index) => (
              <div key={index}>{item ? <ProductItem product={item} /> : null}</div>
            ))}
          </div>
        </>
      )}
    </>
  )
}

export default RelatedProducts
